/**
 * --------------------------------------------------------------------------
 * Basic Modules: BreakPoints.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'breakPoints';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

class BreakPoints {

    constructor(config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this._config  = this._getConfig(config);

        this._addEventListeners();
        this._updateBreakPoint();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _updateBreakPoint() {
        let viewPort = $(window).width(),
            prevBreakPoint = 'xs',
            key, value;

        for (key in Util.breakPoints) {

            if (! Util.breakPoints.hasOwnProperty(key)) {
                continue;
            }

            value = Util.breakPoints[key];

            if (viewPort < value) {
                Util.currentBreakPoint = prevBreakPoint;
                break;
            }

            prevBreakPoint = key;
            Util.currentBreakPoint = key;
        }
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.
        this._updateBreakPoint();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     */
    static init (config) {
        new BreakPoints(config);
    }
}

export default BreakPoints;
